import React from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 h-dvh flex flex-col bg-bg-grey">
      <div onClick={() => navigate(-1)}>
        <img src="/icons/backbtn.svg" alt="" />
      </div>
      <div className="mt-4 text-center text-20">Privacy Policy</div>
      <div className="mt-2 bg-white85 rounded-[10px] p-2 px-3 border-[2px] overflow-y-auto border-[#00000020] flex-1 text-[15px] leading-relaxed">
        <div>
          <p>
            By using our Services through our website or App, you are accepting
            the conditions set out in this Privacy Policy and the related Terms
            and Conditions.
          </p>

          <h3 className="font-semibold mt-4 mb-2">
            WHAT DATA WE COLLECT AND HOW
          </h3>
          <p>
            We may collect, use, store and transfer different kinds of personal
            data about you which we have grouped together as follows:
          </p>

          <h4 className="font-semibold mt-4 mb-1">
            INFORMATION YOU MAKE PUBLIC
          </h4>
          <p>
            By registering you will provide and share some of your personal data
            with the public and with other users i.e. your name and your account
            handle name. This personal data is made available to the public to
            help connect you with other users of our Services. Please be advised
            that public personal data can show up when someone does a search on
            our Services or on another search engine. In some cases, people you
            share and communicate with may download or copy the content you
            provided to them or make it public. Use caution about the personal
            data you share with others.
          </p>

          <h4 className="font-semibold mt-4 mb-1">
            INFORMATION YOU PROVIDE TO US
          </h4>
          <ul className="list-disc pl-4 mb-2">
            <li>
              <strong>Contact Information</strong> such as your name, user ID,
              email address, phone number, and address ("Contact Data").
            </li>
            <li>
              <strong>Sensitive Information</strong> such as race, ethnicity,
              sexual preferences and experiences, political affiliation,
              religious affiliation, union memberships, or any biometric
              information you provide through the use of our Services (your
              "Sensitive Personal Data").
            </li>
            <li>
              <strong>Other information</strong> such as birth date, videos,
              password, billing information, credit card information,
              demographic information, place of work or education, your personal
              interests and background, gender, age, dating age range
              preference, physical characteristics, personal description, life
              experiences, geographic location, your photos, videos and any
              information derived from them (collectively "Extended Data"), and
              any other information you share during the use of our Services.
            </li>
            <li>
              We may collect and process for a limited time, depending on your
              payment mechanism and where applicable, your credit card,
              expiration date, name, address, transaction ID, timestamps, email
              address, bank account, and routing number ("Transaction Data").
            </li>
            <li>
              Mandatory information we are required or authorized by applicable
              laws to collect and process in order to authenticate or identify
              you or to verify the personal data we have collected.
            </li>
          </ul>

          <h4 className="font-semibold mt-4 mb-1">
            INFORMATION PROVIDED BY OTHERS
          </h4>
          <p>
            We may be provided with information relating to you or your conduct
            on our Services by other users. For example, we will collect your
            email address if another user tries to refer Services to you. We
            also collect information that third-party organizations may provide
            to us, such as contact details, demographic information, credit
            reference or fraud prevention information. Financial institutions or
            payment processors may also provide us updated payment information
            or payment methods related to your paid account or paid subscription
            and services.
          </p>

          <h3 className="font-semibold mt-4 mb-2">
            HOW WE USE YOUR PERSONAL DATA
          </h3>
          <ul className="list-disc pl-4 mb-2">
            <li>
              Where we need to perform the contract we are about to enter into
              or have entered into with you for the Services.
            </li>
            <li>
              Where you have given consent for us to use your personal data and
              your Sensitive Personal Data to provide certain Services.
            </li>
            <li>
              Where it is necessary for our legitimate interests (or those of a
              third party) and your interests and fundamental rights do not
              override those interests.
            </li>
            <li>
              Where we need to comply with a legal or regulatory obligation.
            </li>
          </ul>
          <p>
            Unless specifically mentioned, we do not use your personal data for
            any other reason. We will never sell your personal data to a third
            party, and we will never give a third party access to your personal
            data, except as may be provided in our Terms and Conditions or
            unless required to do so by law.
          </p>

          <h3 className="font-semibold mt-4 mb-2">
            PURPOSES FOR WHICH WE WILL USE YOUR PERSONAL DATA
          </h3>
          <ol className="list-decimal pl-4 mb-2">
            <li>
              The Contact Data shared by you shall be used for the purpose of
              creating your profile and proper correspondence with you. The said
              data shall not be shared with any persons except as may be
              provided in our Terms and Conditions or unless required to do so
              by law. Only the user handle shall be shared with a person who
              wants to check compatibility with you.
            </li>
            <li>
              Sensitive personal data shared by you, including your answers to
              the questionnaire given by us, shall not be shared with any
              persons or third party. The person who wants to check
              compatibility with you can only see in which area you are
              compatible and what is the percentage of compatibility.
            </li>
            <li>
              Extended Data and Transaction data shall not be shared with any
              persons except as may be provided in our Terms and Conditions or
              unless required to do so by law.
            </li>
          </ol>

          <h3 className="font-semibold mt-4 mb-2">AGGREGATED DATA</h3>
          <p>
            We may create aggregated data for internal use or for improving
            Services and creating new features. Aggregated data is anonymous and
            is not linked to any personal data. Aggregated information helps
            understand trends and customer needs so that new products and
            services can be considered and so existing products and services can
            be tailored to customer desires. We may share such aggregated data
            with our partners, without restriction, on commercial terms that we
            can determine in our sole discretion.
          </p>

          <h3 className="font-semibold mt-4 mb-2">MARKETING</h3>
          <p>
            We strive to provide you with choices regarding certain personal
            data uses, particularly around marketing and advertising. Where you
            have interacted with us, we will send you marketing communications
            from time to time. Such marketing communications are usually sent by
            email or text (SMS).
          </p>
          <p>
            When you receive communications from Us, including marketing
            communications, we may share your personal data with third party
            companies who help us conduct marketing activities. For example, we
            may use a third party to help us send email messages to you and help
            us understand how you have interacted with that email.
          </p>
          <p>
            Depending on how you are using our Services, your needs and
            preferences, with the purpose to provide you with optimal matching
            possibilities, we may offer you registration with our Linked
            Services, operated by the Data Controller or its affiliated
            companies ("Linked Services"). You may receive marketing information
            from these Linked Services depending on your profile settings and
            our matching algorithm.
          </p>
          <p>
            You hereby agree that we may at our own discretion use any available
            channels of communication (including, but not limited to Email,
            phone, sms, push notifications, Whatsapp, Facebook, and any other
            messengers) for customer support and/or marketing purposes if you
            have provided us with such.
          </p>

          <h3 className="font-semibold mt-4 mb-2">CHANGE OF PURPOSE</h3>
          <p>
            We will generally only use your personal data for the purposes for
            which we collected it. If we need to use your personal data for an
            unrelated purpose, we will notify you and we will explain the legal
            basis which allows us to do so.
          </p>
          <p>
            Please note that we may process your personal data without your
            knowledge or consent, in compliance with the above rules, where this
            is required or permitted by law.
          </p>

          <h3 className="font-semibold mt-4 mb-2">
            DISCLOSURES OF YOUR PERSONAL DATA
          </h3>

          <h4 className="font-semibold mt-4 mb-1">
            OUR SERVICE PROVIDERS AND STAFF
          </h4>
          <p>
            We may share your personal data you provide to us with specially
            selected service providers who assist us in delivering the products
            and services we offer for the sole purpose of providing the services
            or when we consider their services or products to be of interest to
            you. These service providers must adhere to strict confidentiality
            and data transfer obligations in a way that is consistent with this
            Privacy Policy and the agreements we enter into with them.
          </p>

          <h4 className="font-semibold mt-4 mb-1">
            PARTNERSHIPS, AFFILIATES AND AUDIT
          </h4>
          <p>
            We may disclose your personal data to other third parties such as
            our partners, consultors, group companies and affiliates, external
            audit and assessment providers provided they ensure the required
            level of confidentiality and privacy according to the applicable
            laws.
          </p>

          <h4 className="font-semibold mt-4 mb-1">TRANSFER OF BUSINESS</h4>
          <p>
            We may transfer or share a copy of your personal data in cases where
            the Data Controller or one of its properties, affiliates, or
            subsidiaries is part of a business transition, such as a merger,
            being acquired by another company, or selling part of its assets, or
            in the event of bankruptcy, dissolution, divestiture or any related
            or similar proceedings.
          </p>

          <h4 className="font-semibold mt-4 mb-1">LEGAL DEFENSE</h4>
          <p>
            We may share your personal data to, in our discretion, (i) satisfy
            any applicable law, regulation, subpoena/court order, legal process
            or other government request, (ii) enforce our Terms and Conditions,
            including the investigation of potential violations thereof, (iii)
            investigate and defend ourselves against any third party claims or
            allegations, (iv) protect against harm to the rights, our property
            or safety, our users or the public as required or permitted by law
            and (v) detect, prevent or otherwise address criminal (including
            fraud or stalking), security or technical issues.
          </p>

          <h3 className="font-semibold mt-4 mb-2">YOUR LIABILITY</h3>
          <p>
            You hereby confirm and guarantee that you will never generate any
            databases, websites, software, legal entities and services that
            compete with our Services. Such behavior will be fully investigated,
            and necessary legal action will be carried out, including, without
            limitation, civil, criminal, and injunctive redress.
          </p>
          <p>
            We reserve the right to replace, modify or amend this Privacy Policy
            at our own discretion. It is your responsibility to review this page
            and check for any Privacy Policy updates. Please note the latest
            modification date at the bottom of the Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
